import { render } from "./ArticleComment.vue?vue&type=template&id=c15c62ee&ts=true"
import script from "./ArticleComment.vue?vue&type=script&lang=ts"
export * from "./ArticleComment.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__